import React from "react";

import Hidden from "@material-ui/core/Hidden";

import ProductsDesktop from "./ProductsDesktop";
import ProductsMobile from "./ProductsMobile";

function ProductsScreen() {
  const [searchParams, setSearchParams] = React.useState({});
  const [filters, setFilters] = React.useState({});

  const handleSearch = React.useCallback((params) => {
    setSearchParams(params);
  }, []);

  const handleFilter = React.useCallback((params) => {
    setFilters(params);
  }, []);

  return (
    <>
      <Hidden only={["md", "lg", "xl"]}>
        <ProductsMobile
          filters={filters}
          onFilter={handleFilter}
          onSearch={handleSearch}
          searchParams={searchParams}
        />
      </Hidden>
      <Hidden only={["xs", "sm"]}>
        <ProductsDesktop
          filters={filters}
          onFilter={handleFilter}
          onSearch={handleSearch}
          searchParams={searchParams}
        />
      </Hidden>
    </>
  );
}

export default React.memo(ProductsScreen);
